import React, { useState } from 'react';
import { Layout, Row, Col, Typography, Card, Avatar, Space, Divider } from 'antd';
import { 
  UserOutlined, 
  TeamOutlined, 
  HomeOutlined,
  BankOutlined,
  HeartOutlined
} from '@ant-design/icons';
import { theme } from '../../styles/theme';
import { ABOUT_CONTENT } from '../../constants/aboutContent';
import curtPhoto from '../../images/founders/curt.jpeg';
import mohamedPhoto from '../../images/founders/mohamed.jpeg';
import busyHomeownerImg from '../../images/customer-groups/busy-homeowner.png';
import landlordImg from '../../images/customer-groups/landlord.png';
import seniorsImg from '../../images/customer-groups/seniors.png';

const { Content } = Layout;
const { Title, Paragraph, Text } = Typography;

const AboutPage = () => {
  const [hoveredMember, setHoveredMember] = useState(null);
  
  const customers = ABOUT_CONTENT.customers.items.map((customer, index) => ({
    ...customer,
    icon: index === 0 ? <HomeOutlined style={{ fontSize: '24px', color: theme.colors.primary }} /> :
          index === 1 ? <BankOutlined style={{ fontSize: '24px', color: theme.colors.primary }} /> :
          <HeartOutlined style={{ fontSize: '24px', color: theme.colors.primary }} />
  }));

  const teamMembers = ABOUT_CONTENT.team.members.map((member, index) => ({
    ...member,
    photo: index === 0 ? curtPhoto : mohamedPhoto
  }));
  
  const stats = ABOUT_CONTENT.stats;

  return (
    <>
      <Content style={{ 
        padding: '0', 
        background: theme.colors.white,
        minHeight: '100vh'
      }}>
        {/* Hero Section */}
        <section style={{
          background: `linear-gradient(135deg, ${theme.colors.primary} 0%, #ff7a4d 100%)`,
          padding: '120px 0 80px 0',
          textAlign: 'center',
          color: theme.colors.white
        }}>
          <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 24px' }}>
            <Title level={1} style={{ 
              color: theme.colors.white, 
              fontSize: 'clamp(2rem, 5vw, 3.5rem)',
              marginBottom: '1rem',
              fontFamily: theme.fonts.primary,
              fontWeight: '700'
            }}>
              {ABOUT_CONTENT.hero.title}
            </Title>
            <Paragraph style={{ 
              color: theme.colors.white, 
              fontSize: 'clamp(1rem, 2.5vw, 1.25rem)',
              maxWidth: '800px',
              margin: '0 auto',
              opacity: 0.95,
              fontFamily: theme.fonts.primary,
              fontWeight: '500'
            }}>
              {ABOUT_CONTENT.hero.subtitle}
            </Paragraph>
          </div>
        </section>

        {/* Stats Section */}
        {/* <section style={{ padding: '80px 0', background: theme.colors.lightGray }}>
          <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 24px' }}>
            <Row gutter={[32, 32]} justify="center">
              {stats.map((stat, index) => (
                <Col xs={12} sm={6} key={index} style={{ textAlign: 'center' }}>
                  <div>
                    <Title level={2} style={{ 
                      color: theme.colors.primary, 
                      margin: 0,
                      fontSize: 'clamp(1.5rem, 4vw, 2.5rem)',
                      fontFamily: theme.fonts.primary
                    }}>
                      {stat.number}
                    </Title>
                    <Text style={{ 
                      fontSize: '1rem',
                      color: theme.colors.gray,
                      fontFamily: theme.fonts.primary
                    }}>
                      {stat.label}
                    </Text>
                  </div>
                </Col>
              ))}
            </Row>
          </div>
        </section> */}

        {/* Our Story Section */}
        <section style={{ padding: '80px 0' }}>
          <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 24px' }}>
            <Row gutter={[48, 48]} align="middle">
              <Col xs={24} lg={12}>
                <Title level={2} style={{ 
                  color: theme.colors.black,
                  marginBottom: '1.5rem',
                  fontFamily: theme.fonts.primary
                }}>
                  {ABOUT_CONTENT.story.title}
                </Title>
                {ABOUT_CONTENT.story.paragraphs.map((paragraph, index) => (
                  <Paragraph key={index} style={{ 
                    fontSize: '1.1rem',
                    lineHeight: '1.8',
                    color: theme.colors.gray,
                    fontFamily: theme.fonts.primary
                  }}>
                    {paragraph}
                  </Paragraph>
                ))}
              </Col>
              <Col xs={24} lg={12}>
                <div style={{ 
                  background: `linear-gradient(135deg, ${theme.colors.primary}20 0%, #ff7a4d20 100%)`,
                  padding: '40px',
                  borderRadius: theme.borderRadius.xl,
                  textAlign: 'center'
                }}>
                  <TeamOutlined style={{ 
                    fontSize: '4rem', 
                    color: theme.colors.primary,
                    marginBottom: '1rem'
                  }} />
                  <Title level={3} style={{ 
                    color: theme.colors.primary,
                    fontFamily: theme.fonts.primary
                  }}>
                    {ABOUT_CONTENT.story.founderCard.title}
                  </Title>
                  <Text style={{ 
                    fontSize: '1rem',
                    color: theme.colors.gray,
                    fontFamily: theme.fonts.primary
                  }}>
                    {ABOUT_CONTENT.story.founderCard.subtitle}
                  </Text>
                </div>
              </Col>
            </Row>
          </div>
        </section>

        {/* Customers Section */}
        <section style={{ padding: '80px 0', background: theme.colors.lightGray }}>
          <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 24px' }}>
            <div style={{ textAlign: 'center', marginBottom: '4rem' }}>
              <Title level={2} style={{ 
                color: theme.colors.black,
                fontFamily: theme.fonts.primary
              }}>
                {ABOUT_CONTENT.customers.title}
              </Title>
              <Paragraph style={{ 
                fontSize: '1.1rem',
                color: theme.colors.gray,
                maxWidth: '600px',
                margin: '0 auto',
                fontFamily: theme.fonts.primary
              }}>
                {ABOUT_CONTENT.customers.subtitle}
              </Paragraph>
            </div>
            <Row gutter={[32, 32]}>
              {customers.map((customer, index) => {
                // Get the appropriate image for each customer group
                const customerImages = [busyHomeownerImg, landlordImg, seniorsImg];
                const customerImage = customerImages[index];
                
                if (customerImage) {
                  return (
                    <Col xs={24} md={8} key={index}>
                      <Card 
                        style={{ 
                          height: '400px',
                          border: 'none',
                          boxShadow: theme.shadows.lg,
                          borderRadius: theme.borderRadius.xl,
                          overflow: 'hidden',
                          position: 'relative',
                          backgroundImage: `url(${customerImage})`,
                          backgroundSize: 'cover',
                          backgroundPosition: 'center center',
                          backgroundRepeat: 'no-repeat'
                        }}
                        bodyStyle={{ 
                          padding: 0,
                          height: '100%',
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'flex-end'
                        }}
                      >
                        <div style={{
                          background: 'linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.7) 70%, rgba(0,0,0,0.85) 100%)',
                          padding: '2rem',
                          color: theme.colors.white
                        }}>
                          <Title level={4} style={{ 
                            color: theme.colors.white,
                            marginBottom: '0.5rem',
                            fontFamily: theme.fonts.primary,
                            fontWeight: 'bold',
                            textShadow: '0 2px 8px rgba(0,0,0,0.6), 0 1px 3px rgba(0,0,0,0.4)'
                          }}>
                            {customer.title}
                          </Title>
                          <div style={{
                            width: '60px',
                            height: '4px',
                            background: theme.colors.primary,
                            marginBottom: '1rem',
                            borderRadius: '2px'
                          }} />
                          <Paragraph style={{ 
                            color: theme.colors.white,
                            fontFamily: theme.fonts.primary,
                            marginBottom: 0,
                            fontSize: '0.95rem'
                          }}>
                            {customer.description}
                          </Paragraph>
                        </div>
                      </Card>
                    </Col>
                  );
                }
                return null;
              })}
            </Row>
          </div>
        </section>

        {/* Team Section */}
        <section style={{ padding: '80px 0' }}>
          <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 24px' }}>
            <div style={{ textAlign: 'center', marginBottom: '4rem' }}>
              <Title level={2} style={{ 
                color: theme.colors.black,
                fontFamily: theme.fonts.primary
              }}>
                {ABOUT_CONTENT.team.title}
              </Title>
              <Paragraph style={{ 
                fontSize: '1.1rem',
                color: theme.colors.gray,
                maxWidth: '600px',
                margin: '0 auto',
                fontFamily: theme.fonts.primary
              }}>
                {ABOUT_CONTENT.team.subtitle}
              </Paragraph>
            </div>
            <Row gutter={[32, 32]} justify="center">
              {teamMembers.map((member, index) => (
                <Col xs={24} md={12} lg={10} key={index}>
                  <Card 
                    style={{ 
                      height: '100%',
                      textAlign: 'center',
                      border: 'none',
                      boxShadow: theme.shadows.sm,
                      borderRadius: theme.borderRadius.xl
                    }}
                    bodyStyle={{ padding: '2rem' }}
                  >
                    <div
                      onMouseEnter={() => setHoveredMember(index)}
                      onMouseLeave={() => setHoveredMember(null)}
                      style={{ cursor: 'pointer' }}
                    >
                      {hoveredMember === index ? (
                        <img
                          src={member.photo}
                          alt={member.name}
                          style={{
                            width: '80px',
                            height: '80px',
                            borderRadius: '50%',
                            objectFit: 'cover',
                            marginBottom: '1.5rem',
                            border: `3px solid ${theme.colors.primary}`
                          }}
                        />
                      ) : (
                        <Avatar 
                          size={80} 
                          style={{ 
                            backgroundColor: theme.colors.primary,
                            marginBottom: '1.5rem',
                            fontSize: '1.5rem',
                            fontFamily: theme.fonts.primary,
                            fontWeight: 'bold'
                          }}
                        >
                          {member.avatar}
                        </Avatar>
                      )}
                    </div>
                    <Title level={4} style={{ 
                      color: theme.colors.black,
                      marginBottom: '0.5rem',
                      fontFamily: theme.fonts.primary
                    }}>
                      {member.name}
                    </Title>
                    <Text style={{ 
                      color: theme.colors.primary,
                      fontSize: '1rem',
                      fontWeight: 'bold',
                      fontFamily: theme.fonts.primary,
                      display: 'block',
                      marginBottom: '1rem'
                    }}>
                      {member.role}
                    </Text>
                    <Paragraph style={{ 
                      color: theme.colors.gray,
                      fontSize: '0.9rem',
                      lineHeight: '1.6',
                      marginBottom: '1.5rem',
                      fontFamily: theme.fonts.primary
                    }}>
                      {member.bio}
                    </Paragraph>
                    <Divider style={{ margin: '1rem 0' }} />
                    <div>
                      <Text style={{ 
                        color: theme.colors.gray,
                        fontSize: '0.9rem',
                        fontFamily: theme.fonts.primary
                      }}>
                        <strong>Specialties:</strong>
                      </Text>
                      <div style={{ marginTop: '0.5rem' }}>
                        {member.specialties.map((specialty, idx) => (
                          <span 
                            key={idx}
                            style={{
                              display: 'inline-block',
                              background: `${theme.colors.primary}20`,
                              color: theme.colors.primary,
                              padding: '0.25rem 0.75rem',
                              borderRadius: theme.borderRadius.lg,
                              fontSize: '0.8rem',
                              margin: '0.25rem',
                              fontFamily: theme.fonts.primary
                            }}
                          >
                            {specialty}
                          </span>
                        ))}
                      </div>
                    </div>
                  </Card>
                </Col>
              ))}
            </Row>
          </div>
        </section>

        {/* CTA Section */}
      </Content>
    </>
  );
};

export default AboutPage;
